export default __webpack_public_path__ + "static/media/c15.ba881e16.png";